import { handleActions } from 'redux-actions';

import fetchEventSuccess from '../actions/fetchEventSuccess';
import fetchEventError from '../actions/fetchEventError';

import handleFetchEventSuccess from './handleFetchEventSuccess';
import handleFetchEventError from './handleFetchEventError';

export default handleActions(
    {
        [fetchEventSuccess]: handleFetchEventSuccess,
        [fetchEventError]: handleFetchEventError,
    },
    {
        event: null,
        error: null,
        ticketTypes: {},
        priceTypes: {},
    },
);
